import type { ComponentPropsWithoutRef } from 'react';
import { Badge } from '@startupquickstart/frontend';

type PhotoSubmissionStatus = 'pending' | 'approved' | 'rejected';

interface PhotoSubmissionStatusBadgeProps
  extends Omit<ComponentPropsWithoutRef<typeof Badge>, 'variant'> {
  status: PhotoSubmissionStatus;
}

function getStatusConfig(status: PhotoSubmissionStatus) {
  switch (status) {
    case 'pending':
      return { variant: 'warning' as const, label: 'Pending' };
    case 'approved':
      return { variant: 'default' as const, label: 'Approved' };
    case 'rejected':
      return { variant: 'destructive' as const, label: 'Rejected' };
    default:
      return { variant: 'outline' as const, label: 'Unknown' };
  }
}

export function PhotoSubmissionStatusBadge({
  status,
  className,
  ...props
}: PhotoSubmissionStatusBadgeProps) {
  const { variant, label } = getStatusConfig(status);

  return (
    <Badge variant={variant} className={className} {...props}>
      {label}
    </Badge>
  );
}
